import request from "@/utils/request";

export function getPlatFormCate() {
  return request({
    url: "/product/platform-cate/all",
    method: "get",
  });
}
export function getbrand(params) {
  return request({
    url: "/product/participate/part-brand/list",
    method: "get",
    params,
  });
}
